import React from "react";
import { Link } from "react-router-dom";
import { Heart, ShoppingBag } from "lucide-react";
import { useCart } from "../../context/CartContext";

export default function AppWishlist() {
  const { wishlist, toggleWishlist, addToCart } = useCart();
  return (
    <div data-testid="app-wishlist" className="pb-6">
      <header className="px-5 pt-12 pb-4">
        <div className="text-[11px] tracking-luxury uppercase text-poche-gold">Saved</div>
        <h1 className="font-serif text-2xl mt-1">{wishlist.length} pieces saved</h1>
      </header>
      {wishlist.length === 0 ? (
        <div className="px-5 mt-8 text-center text-white/55 text-sm">
          <Heart size={28} className="mx-auto text-poche-gold" strokeWidth={1.2} />
          <p className="mt-3">Save pieces you love by tapping the heart.</p>
          <Link to="/app/shop" className="btn-outline-gold !py-3 !px-5 text-[10px] mt-5 inline-flex">Browse Collection</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-3 px-5">
          {wishlist.map((p) => (
            <div key={p.product_id} data-testid={`app-wish-${p.product_id}`}>
              <div className="bg-poche-ivory aspect-square overflow-hidden relative">
                <img src={p.image} alt={p.name} className="w-full h-full object-cover" />
                <button onClick={() => toggleWishlist({ product_id: p.product_id })} className="absolute top-2 right-2 bg-white w-7 h-7 flex items-center justify-center">
                  <Heart size={12} fill="#0A0A0A" stroke="#0A0A0A" />
                </button>
              </div>
              <div className="mt-2">
                <div className="text-[10px] tracking-luxury uppercase text-white/55">{p.name}</div>
                <div className="font-serif text-base">{p.subtitle}</div>
                <div className="text-poche-gold text-sm">${p.price?.toLocaleString()}</div>
                <button onClick={() => addToCart(p)} className="text-[10px] tracking-luxury uppercase text-poche-gold mt-2 flex items-center gap-1 hover:underline">
                  <ShoppingBag size={11} /> Add to cart
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
